export default {
	title: 'Monthly Report Config',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful'
	},
	labels: {
		monthReportConfig: 'Monthly Report Config'
	},
	buttons: {
		add: 'Add',
		batchDelete: 'Batch Delete',
		edit: 'Edit',
		delete: 'Delete'
	},
	table: {
		projectName: 'Project Name',
		executionMode: 'Execution Mode',
		action: 'Action'
	},
	form: {
		placeholder: {
			projectName: 'Project Name',
			executionMode: 'Execution Mode'
		},
		selectProject: 'Please select owned project',
		selectExecutionMode: 'Please select execution mode'
	},
	config: {
		gridLayout: 'Grid Layout',
		ownedProject: 'Owned Project',
		executionMode: 'Execution Mode',
		day: 'Day',
		week: 'Week',
		month: 'Month'
	},
	dialog: {
		add: 'Add',
		update: 'Edit'
	}
}
